import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { useTheme } from 'next-themes'
import ThemeToggle from './ThemeToggle'
import useAsset from '@/hooks/useAsset'

const TopNavigation = ({
  backTo = "/",
  backText = "Back",
  logo = "/tailtations-text.svg",
  showBackButton = true,
  hideLogo = false
}) => {
  const { theme } = useTheme()
  const [currentTheme, setCurrentTheme] = useState('light')

  // Cache-busted asset URL
  const logoSrc = useAsset(logo)

  // Update theme when it changes
  useEffect(() => {
    const updateTheme = () => {
      const isDark = document.documentElement.classList.contains('dark')
      setCurrentTheme(isDark ? 'dark' : 'light')
    }
    
    updateTheme()
    
    const observer = new MutationObserver(updateTheme)
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class']
    })
    
    return () => observer.disconnect()
  }, [theme])

  return (
    <header className="relative flex items-center justify-center h-20 px-4">
      {/* Back button - positioned absolutely to the left */}
      {showBackButton && (
        <Link 
          to={backTo} 
          className="absolute left-4 flex items-center space-x-2 text-muted-foreground hover:text-foreground transition-colors"
        >
          <ArrowLeft size={20} />
          <span>{backText}</span>
        </Link>
      )}
      
      {/* Centered logo */}
      {!hideLogo && (
        <img
          src={logoSrc}
          alt="Tailtations"
          className="h-12 w-auto"
        />
      )}
      
      {/* Theme toggle - positioned absolutely to the right */}
      <div className="absolute right-4 flex items-center">
        <ThemeToggle />
      </div>
    </header>
  )
}

export default TopNavigation

